import { isArray } from "lodash-es";
import { SeasonTableFilterTypes } from "~pages/Seasons/SeasonListPage/enums/seasonTableFilterTypes.ts";
import type { SeasonTransformed } from "~types/seasonTransformed.ts";

export const filterSeasons = (allSeasons: SeasonTransformed[], currentFilter: Record<string, any>, search: string): SeasonTransformed[] => {
  let data = allSeasons || [];

  Object.keys(currentFilter).forEach((filterKey: string) => {
    const filterType = SeasonTableFilterTypes[filterKey as keyof typeof SeasonTableFilterTypes];
    if (!currentFilter[filterKey] || (isArray(currentFilter[filterKey]) && !currentFilter[filterKey].length)) return;

    const filterValue = currentFilter[filterKey];
    const currentFilterValues = isArray(filterValue) ? filterValue.map((item) => item.value) : [filterValue?.value ?? filterValue];

    if (filterType === SeasonTableFilterTypes.AgeGroup) {
      data = data.filter((x) => currentFilterValues.includes(x.ageGroup));
    }
    if (filterType === SeasonTableFilterTypes.Gender) {
      data = data.filter((x) => currentFilterValues.includes(x.gender));
    }
    if (filterType === SeasonTableFilterTypes.Status) {
      data = data.filter((x) => currentFilterValues.includes(x.status));
    }
    if (filterType === SeasonTableFilterTypes.CompetitionName) {
      data = data.filter((x) => currentFilterValues.includes(x.competitionId));
    }
    if (filterType === SeasonTableFilterTypes.Standard) {
      data = data.filter((x) => currentFilterValues.includes(x.standard));
    }
  });
  if (search) {
    data = data.filter(({ nameLocal }) => nameLocal?.toLowerCase().includes(search.toLowerCase()));
  }

  return data;
};

export default filterSeasons;
